/**
 * Dreht Timeline Ordnung im HTML um für Barrierefreiheit
 */

function initRearangeTimelineOrder() {
    const timelineItems = document.querySelectorAll(".hd-timeline .jet-timeline-item");

    timelineItems.forEach(item => {
        const children = Array.from(item.children);  // Alle Kind-Elemente abrufen
        item.innerHTML = "";  // Den aktuellen Inhalt löschen
        children.reverse().forEach(child => {
            item.appendChild(child);  // Kind-Elemente in umgekehrter Reihenfolge anhängen
        });
    })
}

export { initRearangeTimelineOrder };